import { FC, ReactNode, useRef } from "react";
import * as S from "./styles";
import { SVG } from "../SVG";
import { faClose } from "@fortawesome/pro-light-svg-icons";
import { Portal } from "~/helpers/portal";
import { useUserPilotSearchParams } from "~/hooks/useUserPilotSearchParams";

export interface IModalProps {
  isShowing: boolean;
  hide?: () => void;
  children: ReactNode;
  padding?: string;
  minWidth?: string | number;
  maxWidth?: string | number;
  hideCloseButton?: boolean;
  maxHeight?: string;
  backgroundBlur?: number;
  bgImage?: string;
  fixedElement?: ReactNode;
  id?: string;
  overflow?: string;
  className?: string;
  backgroundColor?: string; // <-- add this line
}

const Modal: FC<IModalProps> = ({
  isShowing,
  className,
  hide,
  children,
  padding,
  minWidth,
  maxWidth,
  maxHeight,
  hideCloseButton,
  backgroundBlur,
  bgImage,
  fixedElement,
  id,
  overflow,
  backgroundColor, // <-- add this
}) => {
  if (!isShowing) return null;

  const handleSearchParamUpdate = useUserPilotSearchParams(id, isShowing);

  const handleHide = () => {
    if (id) handleSearchParamUpdate(false, id);
    if (hide) {
      hide();
    }
  };

  return (
    <Portal>
      <S.ModalWrapper
        className={`${className}-modal-wrapper`}
        onClick={handleHide}
        backgroundBlur={backgroundBlur}
        bgImage={bgImage}>
        <S.ModalContent
          className="modal-content"
          maxHeight={maxHeight}
          maxWidth={maxWidth}
          minWidth={minWidth ? minWidth : "fit-content"}
          padding={padding}
          overflow={overflow ?? "auto"}
          onClick={(e) => e.stopPropagation()}
          style={backgroundColor ? { background: backgroundColor } : undefined} // <-- add this
        >
          {hide && !hideCloseButton ? (
            <S.CloseContainer
              className="modal-close-button"
              onClick={handleHide}>
              <SVG icon={faClose} size="xl" />
            </S.CloseContainer>
          ) : null}
          {children}
        </S.ModalContent>
      </S.ModalWrapper>

      {fixedElement ? <S.FixedElement>{fixedElement}</S.FixedElement> : null}
    </Portal>
  );
};

export default Modal;
